
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "src/thunks/authThunk";

export const LogoutButton = () => {
    const dispatch = useDispatch();
    const authUser = useSelector((state) => state.auth.user);

    const handleLogout = () => {
        console.log("LOGGING OUT OF " + authUser.email)
        dispatch(logoutUser());

    }

    return <button onClick={handleLogout}>Log out</button>
}